import { useEffect, useState } from 'react';
import {
  generatePath,
  useMatch,
  useNavigate,
  useParams,
} from 'react-router-dom';
import {
  SidePanel,
  SidePanelType,
  ButtonPseudo,
  IconLoader,
  PermissionDenied,
  PermissionEnum,
} from '@ui/src';
import { useAppSelector } from '@store';
import { CofStatus } from '../../customers/types';
import CompanyOfficialItem from '../../../components/corporate/overview/company-official-item';
import AddCompanyOfficial from '../../../components/corporate/overview/add-company-official';

import ROUTES from '../../../routes';

import cn from '../corporate.module.css';

const CorporateCustomerCompanyOfficialHOC = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState<'current' | 'removed'>(
    'current',
  );

  const {
    corporateCustomers: {
      info: {
        overview: { companyOfficial },
      },
    },
    root: { activePermissions },
  } = useAppSelector((state) => state);

  const { customerId } = useParams();

  const transactionsMatch = useMatch(
    generatePath(ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_COMPANY_OFFICIAL, {
      customerId: customerId as string,
    }),
  );

  const navigate = useNavigate();

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        transactionsMatch
          ? generatePath(ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_TRANSACTIONS, {
              customerId: customerId as string,
            })
          : generatePath(ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS, {
              customerId: customerId as string,
            }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);
  }, []);

  let content;

  if (
    activePermissions?.includes(
      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION,
    )
  ) {
    if (!companyOfficial) {
      content = (
        <div className={cn.companyOfficialLoader}>
          <IconLoader />
        </div>
      );
    } else {
      content = (
        <>
          <AddCompanyOfficial customerId={customerId} />
          <div className={cn.companyOfficialTabs}>
            <button
              type="button"
              className={`${cn.companyOfficialTab} ${
                selectedTab === 'current' ? cn.companyOfficialTabActive : ''
              }`}
              onClick={() => setSelectedTab('current')}
            >
              Current
            </button>
            <button
              type="button"
              className={`${cn.companyOfficialTab} ${
                selectedTab === 'removed' ? cn.companyOfficialTabActive : ''
              }`}
              onClick={() => setSelectedTab('removed')}
            >
              Removed
            </button>
          </div>
          {selectedTab === 'current' &&
            companyOfficial &&
            companyOfficial?.length > 0 &&
            companyOfficial
              ?.filter(
                (item) =>
                  item.status !== CofStatus.ARCHIVED &&
                  item.status !== CofStatus.REJECTED,
              )

              .map((item) => (
                <CompanyOfficialItem
                  key={item.id}
                  value={item}
                  list={companyOfficial}
                />
              ))}
          {selectedTab === 'removed' &&
            (companyOfficial &&
            companyOfficial?.filter(
              (item) =>
                item.status === CofStatus.ARCHIVED ||
                item.status === CofStatus.REJECTED,
            )?.length > 0 ? (
              companyOfficial
                ?.filter(
                  (item) =>
                    item.status === CofStatus.ARCHIVED ||
                    item.status === CofStatus.REJECTED,
                )
                .map((item) => (
                  <CompanyOfficialItem key={item.id} value={item} removed />
                ))
            ) : (
              <div className={cn.emptyRemoved}>No removed COF yet</div>
            ))}
        </>
      );
    }
  } else {
    content = <PermissionDenied />;
  }

  return (
    <>
      <div id="popup-modal" />
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={handleClose}
        title="Company Official"
        sidepanelExpandedKey="corporate-cof"
        footer={
          <div>
            <ButtonPseudo text="Close" onClick={handleClose} bold />
          </div>
        }
      >
        {content}
      </SidePanel>
    </>
  );
};

export default CorporateCustomerCompanyOfficialHOC;
